import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cc98584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Hello there", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "What do you want to do today?", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "flex-desktop" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Start from scratch and build your event.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Set up your profile and easily create, publish, and manage your events. ", -1))
const _hoisted_8 = {
  key: 1,
  class: "flex-desktop",
  style: {"flex-wrap":"wrap","justify-content":"space-between"}
}

import { calendar } from "ionicons/icons";
import {
  IonPage,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonIcon,
  IonContent,
  IonButton,
} from "@ionic/vue";
import { useUserStore } from "@/stores/user";
import { useWindowWidth } from "@/composition/window";
import EventCard from "@/views/_partials/EventCard.vue";
import { useAppStore } from "@/stores/app";
import { computed, onMounted } from "vue";
import { usePlansStore } from "@/stores/plans";
import { getSubscribedPlans } from "@/api/plans";


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const userStore = useUserStore();
const appStore = useAppStore();
const plansStore = usePlansStore();

const { isMobile } = useWindowWidth();
const dark_mode = computed(() => appStore.settings.theme === "dark");
const limit_events_reached = computed(() => userStore.related.events.length >= plansStore.currentPlan.check_in_max_events)

onMounted(() => {
  fetchCurrentPlan();
})

const fetchCurrentPlan = async () => {
  await plansStore.fetch({ reset: true, page_size: 10 });

  const plan = await getSubscribedPlans();
  let response = plan.data.results;

  let current_plan_id = 0;

 response.forEach((element: any) => {
    if (element.subscription_status === "active") {
      current_plan_id = element.payment_plan;
      return;
    }
  });

  // Get plan information
  await plansStore.fetchPlan(current_plan_id);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("section", {
            class: _normalizeClass(dark_mode.value ? '' : 'colored-bg')
          }, [
            _createElementVNode("div", _hoisted_1, [
              _hoisted_2,
              _hoisted_3,
              (_unref(isMobile) && _unref(userStore).related.events)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).related.events, (event) => {
                      return (_openBlock(), _createBlock(EventCard, {
                        event: event,
                        route: `/event/${event.id}/home`,
                        key: `event-${event.id}`
                      }, null, 8, ["event", "route"]))
                    }), 128)),
                    _hoisted_4
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(IonCard), {
                  class: "new_event-card",
                  "router-link": "/onboarding/new-event",
                  disabled: limit_events_reached.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardHeader), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCardSubtitle), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), { icon: _unref(calendar) }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonCardTitle), null, {
                          default: _withCtx(() => [
                            _createTextVNode(" Create New Event ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCardContent), null, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_unref(IonCard), { class: "my_account-card" }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCardHeader), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCardSubtitle), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonIcon), { icon: _unref(calendar) }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(IonCardTitle), null, {
                          default: _withCtx(() => [
                            _createTextVNode(" My Account ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(IonCardContent), null, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        _createVNode(_unref(IonButton), {
                          color: "primary",
                          class: "ion-margin-top",
                          "router-link": "/my-account"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Go to my account ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              (!_unref(isMobile) && _unref(userStore).related.events)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).related.events, (event) => {
                      return (_openBlock(), _createBlock(EventCard, {
                        event: event,
                        route: `/event/${event.id}/home`,
                        key: `event-${event.id}`
                      }, null, 8, ["event", "route"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})